class AutoupdateDetailsCtrl  
  @$inject: ["$rootScope", "$scope", "$stateParams", "$state", "toasty", "warning", "selector", "Autoupdate"]  
  constructor: ($rootScope, $scope, $stateParams, $state, toasty, warning, selector, Autoupdate)->  
    $rootScope.state = "autoupdates"
    Autoupdate.get({_id: $stateParams._id}).$promise.then (result)=>    
      $scope.autoupdate = result
      $scope.dirty = angular.copy($scope.autoupdate)
    $scope.date = new Date()
    # $scope.listOfCurrentDevice
    $scope.currentPage = 1;
    $scope.deviceStatusFilter = 
      isopen: false
      list: [{abbrev: 'All', name: 'ALL'}, {abbrev:'A', name: 'PENDING'}, {abbrev:'E', name: 'FAILED'}, {abbrev:'C', name: 'COMPLETED'}]
    $scope.filterCurrentStatus = $scope.deviceStatusFilter.list[0]
    $scope.allSelected = false
    $scope.selectedList = {pressingAllCheckButton: false, allSelected: false}
    $scope.lastSelectedDevice = {};
    $scope.selected;
    $scope.options = {}

    $scope.schema = 
      name:
        type: "String"
        display: "Name"
        required: true
      description:
        type: "Text"
        display: "Description"        
      type:
        type: "String"
        enum: [{display: "Immediately", value: "IMMEDIATELY"}, {display: "Next Online", value:"BUNDLE"}]      
      reboot:
        type: "Boolean"
        display: "Reboot after install"
    $scope.save = (dirty)->
      dirty.$save().then (result)->
        angular.copy(result, $scope.autoupdate)
        toasty.success
          title: 'Save Success'
          msg: "Auto update task updated"
      .then ()->
        $scope.dirty.apps = null;
        Autoupdate.get({_id: $stateParams._id}).$promise.then (result)=>    
          $scope.autoupdate = result
          $scope.dirty.apps = angular.copy($scope.autoupdate.apps)
    $scope.remove = (dirty)->
      dirty.$remove().then ()->
        toasty.success
          title: 'Remove Success'
          msg: "Auto update task removed"
        $state.go "autoupdates"

    $scope.publish = (dirty)=>
      dirty.$save().then (result)->
        angular.copy(result, $scope.autoupdate)
        toasty.success
          title: 'Save Success'
          msg: "Auto update task updated"
      .then ()=>           
        options = 
          title: "Publish the auto update"
          msg: "Confirm to publish the auto update task?"
        warning.warn(options)
      .then ()=>
        dirty.$publish()
      .then ()=>
        toasty.success
          title: 'Success'
          msg: 'Publish Success'
      .then ()->
        $scope.dirty.apps = null;
        Autoupdate.get({_id: $stateParams._id}).$promise.then (result)=>    
          $scope.autoupdate = result
          $scope.dirty.apps = angular.copy($scope.autoupdate.apps)
    $scope.assignApp = ($resource)->
      options = 
        model: "Resource"
      if $scope.autoupdate.os is "ANDROID"
        options.filter = 
          type: ["FOLDER", "APK"]
      else if $scope.autoupdate.os is "LINUX"
        options.filter = 
          type: ["FOLDER", "CPK"]
      selector.select(options).then (app)->        
        $scope.dirty.$assignApp app
        $resource.move(1)      

    $scope.assignDevices = ($resource)->
      options = 
        model: "Device"
        filter:
          os: $scope.autoupdate.os      
      
      selector.select(options).then (devices)-> 
        devices.forEach (device)->     
          $scope.dirty.$assignDevice device
        $resource.move(1)      

    $scope.selectStatus = (status)->
      $scope.filterCurrentStatus = status;

    $scope.unassign = (source, resources)->
      idx = resources.indexOf(source)
      resources.splice(idx, 1)

    $scope.updateDevices = ($resource, updateOption) -> 
      devices = []
      devices = $resource.dataset.filter (d)->
        d.$selected is true  
      if updateOption is 'reset'
        if devices and devices.length >0
          options = 
            title: "Reset Device Status"
            msg: "Confirm to reset the below devices? (#{devices.length} in total)"
            model: "AutoupdateDevice"
            devices: devices
        else
          options = 
            title: "Reset Device Status"
            msg: "Confirm to reset the below devices? (#{$resource.list.length} in total)"
            model: "AutoupdateDevice"
            devices: $resource.list
        warning.warn(options)
          .then (result)->
            if devices and devices.length>0
              for device in devices
                idx = $resource.dataset.findIndex (d)->
                  d._id is device._id
                $resource.dataset[idx].status = 'A' 
            else
              $resource.list.forEach (device)->
                device.status = 'A'
            $resource.list.forEach (device)->
              device._id is $scope.lastSelectedDevice._id
              device.$selected = false
            $scope.uncheckAllDevice()
            $resource.move($scope.currentPage) 


      if updateOption is 'unassign'
        if devices and devices.length>0
          options = 
            title: "Remove Devices"
            msg: "Confirm to remove the below devices? (#{devices.length} in total)"
            model: "AutoupdateDevice"
            devices: devices
        else
          options = 
            title: "Remove Devices"
            msg: "Confirm to remove the below devices? (#{$resource.list.length} in total)"
            model: "AutoupdateDevice"
            devices: $resource.list
        warning.warn(options)
        .then (result)->
          if devices and devices.length>0
            newDataset = $resource.dataset.filter (device)->
              !devices.includes device
          else
            newDataset = $resource.dataset.filter (device)-> 
              !$resource.list.includes(device)
          $scope.dirty.devices = newDataset
          $resource.move($scope.currentPage) 

    $scope.selectDevice = (device)->
      $scope.lastSelectedDevice = device;
      $scope.selected = {selectedSource: device, selected: !device.$selected}

    $scope.selectAllDevice = ()->
      $scope.allSelected = !$scope.allSelected
      $scope.selectedList = {pressingAllCheckButton: true, allSelected: $scope.allSelected}

    $scope.uncheckAllDevice = ()->
      $scope.selectedList = { pressingAllCheckButton: true, allSelected: false}

    # $scope.relocateSelectOption = ()->
    #   bodyRect = document.body.getBoundingClientRect();
    #   myElement  = document.getElementsByClassName('filter-select-options');
    #   containerTop = myElement[0].getBoundingClientRect().top - bodyRect.top + 'px';
    #   myContainer = document.getElementsByClassName('my-container');
      # setTimeout(()->
      #     angular.element(myContainer).css({'top':containerTop})
      #   , 50);
    #   return
    
     refreshDeviceList  = ()->
      Autoupdate.get({_id: $stateParams._id}).$promise.then (result)=>    
        $scope.autoupdate = result
        $scope.dirty = angular.copy($scope.autoupdate)



module.exports = AutoupdateDetailsCtrl




// WEBPACK FOOTER //
// ./src/component/autoupdate/details/controller.coffee